import { defaultTo } from 'lodash';
import { AutoRecommendationTypeModel, RecommendationTypeModel } from '.';
import { IModel, Model, ModelRecord } from './Model';
import { StorageContentModel } from './StorageContentModel';

export interface IAssessmentRecommendationModel extends IModel {
  assessmentRecommendationId: number;
  assessmentReferralId: number;
  name: string;
  description: string;
  sortOrder: number;
  isActive: boolean;

  attachmentStorageContentId: number | undefined;
  attachmentStorageContent: StorageContentModel | undefined;

  recommendationTypeId: number;
  recommendationType: RecommendationTypeModel | undefined;

  autoRecommendationTypeId: number | undefined;
  autoRecommendationType: AutoRecommendationTypeModel | undefined;
  autoRecommendationValue: string;
}

export class AssessmentRecommendationModel
  extends Model
  implements ModelRecord<IAssessmentRecommendationModel>
{
  assessmentRecommendationId: number;
  assessmentReferralId: number;
  name: string;
  description: string;
  sortOrder: number;
  isActive: boolean;

  attachmentStorageContentId: number | undefined;
  attachmentStorageContent: StorageContentModel | undefined;

  recommendationTypeId: number;
  recommendationType: RecommendationTypeModel | undefined;

  autoRecommendationTypeId: number | undefined;
  autoRecommendationType: AutoRecommendationTypeModel | undefined;
  autoRecommendationValue: string;

  constructor(params?: Partial<IAssessmentRecommendationModel>) {
    super(params);
    this.assessmentRecommendationId = defaultTo(
      params?.assessmentRecommendationId,
      0,
    );
    this.assessmentReferralId = defaultTo(params?.assessmentReferralId, 0);
    this.name = defaultTo(params?.name, '');
    this.description = defaultTo(params?.description, '');
    this.sortOrder = defaultTo(params?.sortOrder, 999);
    this.isActive = defaultTo(params?.isActive, true);

    this.attachmentStorageContentId = defaultTo(
      params?.attachmentStorageContentId,
      undefined,
    );
    this.attachmentStorageContent = params?.attachmentStorageContent
      ? new StorageContentModel(params.attachmentStorageContent)
      : undefined;

    this.recommendationTypeId = defaultTo(params?.recommendationTypeId, 0);
    this.recommendationType = params?.recommendationType
      ? new RecommendationTypeModel(params?.recommendationType)
      : undefined;

    this.autoRecommendationTypeId = defaultTo(
      params?.autoRecommendationTypeId,
      undefined,
    );
    this.autoRecommendationType = params?.autoRecommendationType
      ? new AutoRecommendationTypeModel(params?.autoRecommendationType)
      : undefined;
    this.autoRecommendationValue = defaultTo(
      params?.autoRecommendationValue,
      '',
    );
  }
}
